// extracted by mini-css-extract-plugin
export default {"column":"TopicFilesEditComponent_column__UHMeh","body":"TopicFilesEditComponent_body__Sc7eM"};